<template>
  <div class="product-details">
    <div class="title">
      {{ title }}产品明细
    </div>
    <!-- table row -->
    <div class="table-box">
      <el-table
        ref="multipleTable"
        :data="tableData"
        border
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="left"
        />
        <el-table-column
          prop="productCode"
          label="销售产品代码"
          align="left"
        />
        <el-table-column
          prop="productName"
          label="产品型号"
          align="left"
        />
        <el-table-column
          prop="materialNum"
          label="料号"
          align="left"
        />
        <el-table-column
          prop="productNum"
          label="数量"
          align="left"
        />
        <el-table-column
          prop="beforeSplitPrice"
          label="拆分前单价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="productPriceAdd"
          label="拆分前总价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="productActualPrice"
          label="实际结算单价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="productActualPriceAdd"
          label="实际结算总价"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="expectedDeliveryDate"
          label="期望发货日期"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.expectedDeliveryDate || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="taxRate"
          label="税率"
          align="right"
          header-align="left"
        />
        <el-table-column
          prop="remarks"
          label="备注"
          align="left"
        >
          <template slot-scope="scope">
            {{ scope.row.remarks || '-' }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: '罚金合同'
    },
    tableData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {

    };
  },
  components: {},
  computed: {},
  methods: {}
};
</script>
<style lang="scss" scoped>
.product-details{
  margin-top: 12px;
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
  .title{
    color: #383838;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
  }
}
.flex{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.ml-18{
  margin-left: 18px;
}
.btn-disabled{
  color: #B8B8B8;
  font-size: 14px;
  border-radius: 4px;
  background-color: rgba(245,245,245,1);
  border: 1px solid #d9d9d9;
}
</style>

<style lang="scss" scoped>
.table-box{
  ::v-deep .el-table__footer-wrapper {
    tbody {
      td.el-table__cell{
      background-color: transparent;
      font-weight: bold;
    }
   }
  }
}
</style>
